module.exports = "<div class=\"lui-checkbox__wrapper lui-interactive\">\n  <div class=\"lui-checkbox__indicator lui-radiobutton__indicator\"></div>\n  <svg viewBox=\"0 0 20 20\" class=\"lui-checkbox__checked\">\n    <circle class=\"lui-checkbox__icon\" cx=\"10\" cy=\"10\" r=\"8\"></path>\n  </svg>\n  <input seedelement type=\"radio\">\n  <label class=\"lui-checkbox__label\">\n    <slot></slot>\n  </label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-radiobutton/theme/lui-radiobutton.html
// module id = 293
// module chunks = 0 1 15